import type { AudioInputDevice, AudioOutputDevice } from './audioDeviceTypes';

// Chromium lists the default and the communications device a second time under fixed ids.
const PSEUDO_DEVICE_IDS = new Set(['default', 'communications']);

const isPhysical = (device: MediaDeviceInfo, kind: MediaDeviceKind) =>
  device.kind === kind && !PSEUDO_DEVICE_IDS.has(device.deviceId);

export function filterAudioInputs(devices: MediaDeviceInfo[]): AudioInputDevice[] {
  return devices
    .filter((device) => isPhysical(device, 'audioinput'))
    .map(({ deviceId, label }) => ({ deviceId, label }));
}

export function filterAudioOutputs(devices: MediaDeviceInfo[]): AudioOutputDevice[] {
  return devices
    .filter((device) => isPhysical(device, 'audiooutput'))
    .map(({ deviceId, label, groupId }) => ({ deviceId, label, groupId }));
}

/** The physical speaker behind Chromium's `default` output shares its group id. */
export function defaultOutputGroupId(devices: MediaDeviceInfo[]): string | null {
  const pseudoDefault = devices.find(
    (device) => device.kind === 'audiooutput' && device.deviceId === 'default'
  );
  return pseudoDefault?.groupId ?? null;
}
